export default {"src":"/_next/static/media/MyprofileChevronRight.b33c9c98.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};